export default __webpack_public_path__ + "static/media/instagram.e15f34ae.svg";